import { useCallback, useMemo, useState } from 'react';

import { format } from 'date-fns';
import { HiDotsVertical } from 'react-icons/hi';
import { useHistory, useParams } from 'react-router-dom';

import { Modal } from '~/components';
import { useDataSheets } from '~/hooks/dataSheets';

import {
  CardContainer,
  CardLine,
  CardLineLabel,
  CardLineValue,
  Container,
  Options,
  DeleteModalContainer,
} from './styles';

type DataSheet = {
  id: number;
  date: string;
};

type Props = {
  dataSheet: DataSheet;
};

type RouteParams = {
  userId: string;
};

export function DataSheetCard({ dataSheet }: Props) {
  const { push } = useHistory();
  const { userId } = useParams<RouteParams>();
  const { deleteDataSheet } = useDataSheets();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleNavigateToDataSheet = useCallback(() => {
    push(`/professional/students/${userId}/datasheet/${dataSheet.id}`);
  }, [push, userId, dataSheet]);

  const handleNavigateToEditDataSheet = useCallback(() => {
    push(`/professional/students/${userId}/datasheet/${dataSheet.id}/edit`);
  }, [push, userId, dataSheet]);

  const handleDeleteStudentDataSheet = useCallback(async () => {
    deleteDataSheet(dataSheet.id);

    setShowDeleteModal(false);
  }, [dataSheet, deleteDataSheet]);

  const cardData = useMemo(
    () => ({
      id: dataSheet?.id,
      date: format(new Date(dataSheet?.date), `dd/MM/yyyy`),
    }),
    [dataSheet],
  );

  function DeleteModal() {
    return (
      <Modal isOpen={showDeleteModal} setOpen={setShowDeleteModal}>
        <DeleteModalContainer>
          <h1>Atenção</h1>

          <p>
            Ao clicar em SIM excluirá a ficha técnica de ID: {dataSheet.id}.
            <br />
            Tem certeza que deseja continuar?
          </p>

          <div>
            <button type="button" onClick={handleDeleteStudentDataSheet}>
              Sim
            </button>
            <button type="button" onClick={() => setShowDeleteModal(false)}>
              Não
            </button>
          </div>
        </DeleteModalContainer>
      </Modal>
    );
  }

  return (
    <Container>
      <DeleteModal />

      <CardContainer onClick={handleNavigateToDataSheet}>
        <CardLine>
          <span>
            <CardLineLabel>ID:</CardLineLabel>
            <CardLineValue>{cardData.id}</CardLineValue>
          </span>
          <span>
            <CardLineLabel>Data:</CardLineLabel>
            <CardLineValue>{cardData.date}</CardLineValue>
          </span>
        </CardLine>
      </CardContainer>

      <Options>
        <HiDotsVertical size={20} color="#000" />

        <div>
          <button onClick={handleNavigateToEditDataSheet} type="button">
            Editar
          </button>

          <div className="divider" />

          <button onClick={() => setShowDeleteModal(true)} type="button">
            Excluir
          </button>
        </div>
      </Options>
    </Container>
  );
}
